import { render, staticRenderFns } from "./PlannedMeasures.vue?vue&type=template&id=219239bc&scoped=true&"
import script from "./PlannedMeasures.vue?vue&type=script&lang=ts&"
export * from "./PlannedMeasures.vue?vue&type=script&lang=ts&"
import style0 from "./PlannedMeasures.vue?vue&type=style&index=0&id=219239bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219239bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VCol,VDataTable,VRow,VSkeletonLoader,VTextField})
